import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted } from 'vue';
import { useCacheCommentTextareaHeight } from './composables/use-cache-comment-textarea-height';
import { useFixHeight } from './composables/use-fix-height';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentTextareaHandler',
  setup(__props) {

function getCommentFooter() {
    return document.querySelector('.comment-footer') as HTMLElement;
}

function getCommentFooterHeight() {
    const commentFooter = getCommentFooter();
    return commentFooter.offsetHeight;
}

const {
    saveHeightToCache,
    getHeightFromCache,
} = useCacheCommentTextareaHeight();

function updateCommentFooterHeight(height: number) {
    const commentFooter = getCommentFooter();
    if (commentFooter) {
        commentFooter.style.height = `${height}px`;
    }
}

let lastHeight = 0;
let lastY = -1;

const { fixHeight } = useFixHeight();

function handleMouseMove(e: MouseEvent) {
    e.preventDefault();
    const y = e.clientY;
    if (lastY !== -1) {
        const offsetY = y - lastY;
        const height = fixHeight(lastHeight - offsetY);
        updateCommentFooterHeight(height);
    }
}

const disposes: (() => void)[] = [];

function dispose() {
    disposes.forEach(dispose => dispose());
}

function handleMouseUp() {
    const height = getCommentFooterHeight();
    saveHeightToCache(height);
    dispose();
}

function handleMouseDown(e: MouseEvent) {
    lastY = e.clientY;
    lastHeight = getCommentFooterHeight();
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    disposes.push(() => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    });
}

onMounted(() => {
    const height = getHeightFromCache();
    updateCommentFooterHeight(fixHeight(height));
});

function resetCommentFooterHeight() {
    const commentFooter = getCommentFooter();
    if (commentFooter) {
        commentFooter.style.height = '';
    }
}

onBeforeUnmount(() => {
    dispose();
    resetCommentFooterHeight();
});

return { __sfc: true,getCommentFooter, getCommentFooterHeight, saveHeightToCache, getHeightFromCache, updateCommentFooterHeight, lastHeight, lastY, fixHeight, handleMouseMove, disposes, dispose, handleMouseUp, handleMouseDown, resetCommentFooterHeight }
}

})